import React from 'react';
import { BellIcon } from 'lucide-react';
interface NotificationBellProps {
  count: number;
}
const NotificationBell: React.FC<NotificationBellProps> = ({
  count
}) => {
  return <div className="relative inline-block" data-id="element-460">
      <button className="p-2 rounded-full hover:bg-gray-100 relative focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-461">
        <BellIcon size={20} className="text-gray-600" data-id="element-462" />
        {count > 0 && <span className="absolute top-0 right-0 h-5 w-5 bg-red-500 text-white text-xs flex items-center justify-center rounded-full" data-id="element-463">
            {count}
          </span>}
      </button>
    </div>;
};
export default NotificationBell;